import { render, staticRenderFns } from "./DeckArcs.vue?vue&type=template&id=014d4c4c"
import script from "./DeckArcs.vue?vue&type=script&lang=js"
export * from "./DeckArcs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports